<template>
  <div class="h-full text-base">
    <ThreadsNav :show-center="false" class="w-full" show-back>
      <template #right>
        <div @click="router.push({ name: 'withdrawalRecords' })">
          {{ $t(`Payment.withdrawRecord`) }}
        </div>
      </template>
    </ThreadsNav>
    <div class="px-5">
      <div class="text-white font-bold">
        <p>{{ t(`Payment.currentAccountBalance`) }}</p>
        <p>$ {{ user?.balance }}</p>
      </div>
      <div class="flex items-center gap-2 mb-5">
        <div class="flex-1 text-my-gray font-bold">
          <p class="flex items-center gap-1 h-8">
            {{ t(`Payment.useableBalance`) }}
          </p>
          <p>$ {{ (user?.balance || 0) - (user?.frozenBalance || 0) }}</p>
        </div>
        <div class="flex-1 text-my-gray font-bold">
          <p class="flex items-center gap-1">
            {{ t(`Payment.freeze`) }}
            <i class="iconfont icon-Help text-sm p-1 mt-1" @click="clickTip" />
          </p>
          <p>$ {{ user?.frozenBalance }}</p>
        </div>
      </div>

      <div class="my-5 text-sm text-my-gray">
        <p>
          <span>{{ t(`Payment.nextAutoPayTime`) }}: </span>
          <span>
            {{ moment().add(1, "month").set("date", 15).format("YYYY-MM-DD") }}
          </span>
        </p>
        <p class="text-xs mt-1">
          <span>{{ t(`Payment.payTip`) }}</span>
        </p>
      </div>

      <div class="my-5">
        <p class="font-bold">{{ t(`Payment.minAutoWithdrawal`) }}</p>

        <div class="relative">
          <VanField
            v-model.number="minAmount"
            class="mt-4 pl-8"
            type="number"
          />
          <div class="absolute left-2.5 top-2.5 text-my-gray">$</div>
        </div>
      </div>

      <div class="my-5 text-sm text-my-gray">
        <p class="text-xs mt-1">{{ $t(`Payment.autoTip`) }}</p>
      </div>

      <div class="my-5">
        <p class="font-bold mb-1">{{ t(`Payment.withdrawToPaypal`) }}</p>
        <p class="text-sm font-light">{{ user?.paypal }}</p>
        <button
          class="btn btn-primary btn-sm mt-4"
          @click="router.push({ name: 'paypal' })"
        >
          {{ $t(`Payment.replaceBind`) }}
        </button>
      </div>

      <div class="flex flex-col items-center mt-10">
        <button
          class="btn btn-primary btn-sm mb-3 min-w-[120px]"
          @click="clickSave"
        >
          {{ $t(`Buttons.save`) }}
        </button>
        <button
          class="btn btn-primary btn-sm min-w-[120px]"
          @click="router.back"
        >
          {{ $t(`Buttons.cancel`) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import api from "@/modules/api";
import {
  showDialog,
  showFailToast,
  showLoadingToast,
  showSuccessToast,
} from "vant";
import moment from "moment-timezone";
import { computed } from "vue";
import { sessionStorageGet } from "@/tools/sessionStorage";
import { useRouter } from "vue-router";
import { useGlobalUser } from "@/stores/globalUser";

const { t } = useI18n();
const user = ref<User>();
const router = useRouter();
const userStore = useGlobalUser();
// const withdraw = ref<number>();
const minAmount = ref(100);

const predictAmount = computed(() => {
  return Math.max(user.value?.balance || 0, minAmount.value);
});

const clickTip = () => {
  showDialog({
    title: t(`Payment.freeze`),
    message: t(`Payment.freezeTip`),
    confirmButtonText: t(`Buttons.confirm`),
  });
};

const clickSave = async () => {
  const loading = showLoadingToast({ message: t(`Message.loading`) });
  if (minAmount.value < 1) return showFailToast(t(`Payment.withdrawAmountMin`));
  await userStore.updateUserApi({ minWithdrawalAmount: minAmount.value });
  loading.close();
  showSuccessToast({ message: t(`Message.successfully`) });
};

onMounted(async () => {
  user.value = sessionStorageGet("user");
  minAmount.value = user.value?.minWithdrawalAmount || 100;
  user.value = (await api.readUserHome()).data;
  minAmount.value = user.value?.minWithdrawalAmount || 100;
});
</script>
